import { QueryList } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { asEnumerable } from 'linq-es2015';
import { FlatInstructionsFormComponent } from './flat-instructions-form/flat-instructions-form.component';
var FlatInstructionsComponent = /** @class */ (function () {
    function FlatInstructionsComponent() {
    }
    FlatInstructionsComponent.prototype.ngOnInit = function () {
        var substrates = asEnumerable(this.ceRequestOptions.substrates)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.requiresFollowup; })
            .ThenBy(function (s) { return s.name; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.name
            };
        })
            .ToArray();
        var irrigations = asEnumerable(this.ceRequestOptions.irrigations)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.requiresFollowup; })
            .ThenBy(function (s) { return s.name; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.name
            };
        })
            .ToArray();
        var fertigations = asEnumerable(this.ceRequestOptions.fertigations)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.requiresFollowup; })
            .ThenBy(function (s) { return s.name; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.name
            };
        })
            .ToArray();
        var flatTypes = asEnumerable(this.ceRequestOptions.flatTypes)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.name; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.name
            };
        })
            .ToArray();
        this.flatInstructionsOptions = {
            flatTypes: flatTypes,
            substrates: substrates,
            irrigations: irrigations,
            fertigations: fertigations
        };
    };
    Object.defineProperty(FlatInstructionsComponent.prototype, "treatments", {
        get: function () {
            return this.experimentDesignFormGroup.get("treatments");
        },
        enumerable: true,
        configurable: true
    });
    FlatInstructionsComponent.prototype.applyAll = function (sourceComponent) {
        var args = {
            directSeedToPots: sourceComponent.directSeedToPots.value,
            flatType: sourceComponent.flatType.value,
            substrate: sourceComponent.substrate.value,
            irrigation: sourceComponent.irrigation.value,
            fertigation: sourceComponent.fertigation.value
        };
        this.flatInstructionForms.forEach(function (f) { return f.copyValueFrom(args); });
    };
    return FlatInstructionsComponent;
}());
export { FlatInstructionsComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/flat-instructions/flat-instructions.component.ts.pre-build-optimizer.js